export const buildQueryName = (query: string, prefix?: string) => {
  if (prefix) return `${prefix}_${query}`;

  return query;
};
